import React from 'react'

export default function User_dashboard() {
  return (
    <div>
      <h1>Hello User here</h1>
    </div>
  )
}
